export default {
    common: {
        meta: {
            title: 'CrispyVoice',
            subTitle: 'The voice of your future'
        },
        mediums: {
            commercials: {
                title: 'Commercials',
                examples: 'TV, Billboards, YouTube and Radio'
            },
            'info-videos': {
                title: 'Info Videos',
                examples: 'E-Learning, Product video, Image video'
            },
            'social-media': {
                title: 'Social Media',
                examples: 'Facebook, YouTube, Instagram, TikTok'
            },
            public: {
                title: 'Public',
                examples: 'Fire alarm, PA, Shooter alarm'
            },
            layout: {
                title: 'Layout'
            },
            'e-learning': {
                title: 'E-Learning',
                examples: 'Online courses, training videos, tutorials'
            }
        },
        buttons: {
            cancel: 'Cancel',
            back: 'Back',
            submit: 'Submit'
        },
        errors: {
            somethingWentWrong: 'Something went wrong!'
        },
        formats: {
            mp3: 'MP3',
            wav: 'WAV'
        },
        timeframes: {
            day_one: 'day',
            day_other: 'days',
            week_one: 'week',
            week_other: 'weeks',
            month_one: 'month',
            month_other: 'months',
            year_one: 'year',
            year_other: 'years'
        },
        landing: {
            title: 'Choose a Voice',
            subtitle: 'Select one of the available AI voices below.'
        },
        'contact-speaker': 'Contact {{shortName}}',
        'api-contact-form-description':
            'Are you interested in connecting directly to my AI voice, without the need to go through this website?',
        'contact-form-instruction': 'Please fill out the form below and I will get back to you as soon as possible.',
        'api-contact-form-instruction':
            'Please fill out the form below and I will get back to you as soon as possible.',
        'contact-form-description':
            'Did my AI voice not meet your expectations? Not enough emotion? You can also work with my natural voice!',
        'email-invalid': 'Invalid email address',
        'email-required': 'Email is required',
        'email-too-short': 'Email is too short',
        'email-too-long': 'Email is too long',
        'navigate-to-home': 'Generate audio'
    },
    'core-shop': {
        topbar: {
            'ai-vs-ai': 'With AI, against AI',
            'voice-owner-approved': 'Voice Owner Approved',
            'ai-act-ready': 'AI Act Ready',
            'hybrid-voice': 'Hybrid Voice',
            'card-payment': 'Credit card payment',
            languages: '25+ languages'
        },
        nav: {
            login: 'Login',
            api: 'Request API',
            contact: 'Contact',
            theme: 'Toggle light/dark theme'
        },
        hero: {
            'headline-main': 'The first licensed AI voice.',
            'headline-accent': 'Legally secure. AI Act compliant.',
            'compare-natural': 'Natural Voice',
            'compare-clone': 'Clone Voice / Alter Ego',
            'no-demos': 'No audio demos are currently available for this style.',
            'cta-clone': 'Try the AI voice for free',
            'cta-natural': 'Book Natural Voice',
            'why-title': "Here's why you should choose CrispyVoice",
            'why-1': 'Voice Owner Approved',
            'why-2': 'Release document included',
            'why-3': 'Legally secure under Swiss/EU law',
            'why-4': 'AI Act compliant',
            caption: 'No sign-up · ready in seconds · from {{currency}} {{price}}'
        },
        voicings: {
            label: '{{count}} Voicings',
            title: 'One voice. Several use cases.',
            subtitle: 'Pick a voice, test it and buy directly — no account needed.'
        },
        demo: {
            title: 'Listen first. Buy then.',
            subtitle: 'Enter your text, generate a preview and then pick the matching use case.',
            generate: 'Generate',
            generating: 'Generating …',
            disclaimer: 'ⓘ Preview has a watermark. Your purchased file comes without it — with a release document.',
            'no-voice-data': 'The demo is currently unavailable for this voice.'
        },
        usecase: {
            question: 'What will you use the voice for?',
            subtitle: 'Your price depends on the use case — not on the text length.',
            'price-from': 'from {{currency}} {{price}}',
            free: 'Free'
        },
        checkout: {
            'excl-vat': 'excl. VAT',
            'ai-act': 'AI Act compliant',
            'takes-title': 'Your takes',
            'takes-note': 'The price is calculated per recording from the total characters of its selected takes.',
            buy: 'Place order',
            'summary-title': 'Summary',
            'selected-takes': 'Selected takes',
            'total-characters': 'Total characters',
            'character-value': '{{count}} / {{included}} included',
            'take-count_one': '{{count}} take',
            'take-count_other': '{{count}} takes',
            'recording-details_one': 'Recording {{number}} · {{characters}} characters · {{count}} take',
            'recording-details_other': 'Recording {{number}} · {{characters}} characters · {{count}} takes',
            'base-price-details':
                'Base price {{currency}} {{price}} · {{included}} characters included · then {{currency}} {{rate}} / character',
            'additional-price-details':
                '{{currency}} {{basePrice}} + {{characters}} characters × {{currency}} {{rate}} = {{currency}} {{totalPrice}}',
            'remove-recording': 'Remove recording {{number}} from the order',
            medium: 'Use case',
            license: 'License',
            'base-price': 'Base price',
            total: 'Total'
        },
        order: {
            label: 'Generate now',
            intro: '4 steps to your finished AI voice: generate, choose your use case, pay, download.',
            'progress-label': 'Order progress',
            progress: 'Step {{current}} of {{total}} · {{step}}',
            steps: {
                generate: 'Generate',
                use: 'Choose use case',
                review: 'Review & pay'
            },
            'voice-hint': 'Choose a style – switch any time, each sounds noticeably different:',
            'takes-title': 'Choose your takes',
            characters: '{{count}} characters selected',
            recording: 'Recording {{number}}',
            version: 'Version {{number}}',
            'character-short': 'chars',
            'buy-take': 'buy',
            'delete-take': 'Delete take',
            generated_zero: '{{count}} versions generated',
            generated_one: '{{count}} version generated',
            generated_other: '{{count}} versions generated',
            'price-from': 'from {{currency}} {{price}}',
            price: '{{currency}} {{price}}',
            'to-use': 'Continue to use case',
            'to-review': 'Continue to review',
            'use-subtitle': 'Your choice determines the license period and price.',
            'api-note': 'Looking for an API integration, for example for voice bots?',
            'api-contact': 'Request API access →',
            back: 'Back'
        },
        usp: {
            label: 'Why Alter Ego by CrispyVoice',
            '1-title': 'Voice Owner Approved',
            '1-text': 'Release certificate per file included. Legally secure. Period.',
            '2-title': 'AI Act Ready',
            '2-text': 'GDPR compliant. EU AI Act compliant. Zero legal risk for you.',
            '3-title': 'Multiple voicings',
            '3-text': 'Every medium gets its matching style. Each voicing freely applicable.',
            '4-title': 'Hybrid Voice',
            '4-text': 'Book the original or the Alter Ego. You decide what you need.'
        },
        testimonials: {
            label: 'Client reviews'
        },
        cta: {
            title: 'Ready? And please!',
            subtitle: 'Try first, then buy. No commitment.',
            primary: 'Try now',
            secondary: 'Request Natural Voice'
        },
        'natural-booking': {
            title: 'Natural Voice Booking',
            subtitle: 'Professional live recording with {{speaker}}',
            close: 'Close dialog',
            'selected-speaker': 'Selected Speaker',
            name: 'Name',
            'name-placeholder': 'John Doe',
            email: 'Email',
            'email-placeholder': 'john@company.com',
            company: 'Company / Organisation',
            'company-placeholder': 'My Company Ltd.',
            street: 'Street',
            'street-placeholder': 'Main Street',
            'street-nr': 'No.',
            'street-nr-placeholder': '123',
            zip: 'ZIP Code',
            'zip-placeholder': '12345',
            city: 'City',
            'city-placeholder': 'Berlin',
            country: 'Country',
            medium: 'Medium / Purpose',
            'select-placeholder': 'Please select...',
            countries: {
                DE: 'Germany',
                AT: 'Austria',
                CH: 'Switzerland',
                LI: 'Liechtenstein',
                LU: 'Luxembourg',
                FR: 'France',
                IT: 'Italy',
                NL: 'Netherlands',
                BE: 'Belgium',
                GB: 'United Kingdom',
                US: 'United States',
                OTHER: 'Other'
            },
            media: {
                podcast: 'Podcast',
                youtube: 'YouTube Video',
                commercial: 'Advertising / Commercial',
                audiobook: 'Audiobook',
                elearning: 'E-Learning / Training',
                imagefilm: 'Corporate Film',
                social: 'Social Media',
                other: 'Other'
            },
            file: 'Upload Text / Script',
            'file-select': 'Choose file',
            'file-hint': 'TXT, DOC, DOCX, PDF (max 10 MB)',
            'file-remove': 'Remove',
            message: 'Message / Project Details',
            'message-placeholder': 'Describe your project: desired tone, deadlines, special requirements...',
            submit: 'Send Request',
            submitting: 'Sending...',
            'success-title': 'Request sent successfully!',
            'success-message': 'We will get back to you within 24 hours.',
            errors: {
                'file-size': 'The file is too large (max 10 MB).',
                'file-type': 'Invalid file type. Allowed: TXT, DOC, DOCX and PDF.',
                send: 'The request could not be sent. Please try again.'
            }
        },
        footer: {
            left: 'CrispyVoice GmbH · Hünenberg, Switzerland · With AI, against AI.'
        }
    },
    hero: {
        title: 'Your AI voice. Directly from the voice actor. Legally secure. Period.',
        subTitle:
            'In 4 steps to your finished AI voice: Choose use case, generate, pay, download. ✓ Release Document included.',
        'listen-to-my-voice': 'Listen to my voice!',
        'voice-demo': {
            natural: 'Natural Voice',
            clone: 'Clone Voice',
            'book-natural': 'Book Natural Voice',
            'book-clone': 'Book Clone Voice'
        },
        'read-full-testimonial': 'Read full testimonial',
        reviews: 'reviews'
    },
    testimonials: {
        title: 'What customers say about my AI voice'
    },
    'medium-selection': {
        header: 'What do you need my AI voice for?',
        'price-from': 'from {{currency}} {{basePrice}}',
        'price-free': 'free of charge',
        'included-characters': '{{included}} characters included',
        'price-additional-characters': '{{currency}} {{price}} / additional character',
        'unrestricted-usage': 'Perpetual license',
        'restricted-usage': '{{value}} $t(common:timeframes.{{unit}}, { "count": {{value}} }) license',
        api: {
            title: 'Interface',
            subTitle: 'upon request'
        }
    },
    imprint: {
        title: 'Imprint',
        contact: 'Contact Artist',
        'contact-artist': 'Contact artist',
        'contact-platform': 'Contact CrispyVoice',
        'responsible-for-platform': 'Responsible for platform',
        'contact-artist-description': 'If you would like to contact me directly, please use this form.',
        'contact-platform-description': 'For questions about the platform itself, please use this form.'
    },
    'audio-generation': {
        header: 'Enter text. Generate. Listen.',
        'copy-protection-info':
            'The background voice tag? Just a preview watermark. Your purchased file comes without it.',
        buttons: {
            generate: 'Generate',
            'generate-audio': 'Generate audio',
            'please-wait': 'Please wait...',
            cancel: 'Cancel generation',
            stop: 'Stop',
            play: 'Play',
            'contact-support': 'Contact'
        },
        'autoplay-blocked': 'Audio is ready. Tap to play.',
        'consent-required-title': 'Consent Required',
        'character-limit-exceeded-explanation-anonymous':
            'This text exceeds the {{limit}} character limit. <0>Register with your email address</0> to generate longer texts.',
        'character-limit-exceeded-explanation':
            'This text exceeds the {{limit}} character limit. Want to generate even longer texts? <0>Contact us</0> and we’ll find the right solution for you.',
        'character-limit-contact-topic': 'Request for longer text generation',
        'character-limit-contact-description':
            'Tell us about the length and volume of the texts you would like to generate, and we’ll get back to you.',
        'consent-required-message':
            'We need your consent to use functional cookies that help prevent abuse and ensure fair usage of our service.',
        'accept-cookies': 'Accept Cookies',
        'create-account': 'Create Account',
        'anonymous-limit-reached-title': 'Generate more? Und bitte!',
        'anonymous-limit-reached-message': 'Enter email and keep going.',
        'character-limit-exceeded': 'Text exceeds the {{limit}} character limit for anonymous users',
        'generations-remaining': '{{remaining}} generations left today',
        email: 'Email',
        'sign-in': 'Sign In',
        'marketing-consent':
            'I consent to receive marketing emails from CrispyVoice, including updates about new voices, features, and offers.',
        'text-placeholder': 'Enter text here',
        'recording-name': 'Recording {{position}}',
        or: 'or',
        'take-name': 'Version {{position}}',
        'advanced-options': 'Advanced options',
        'reset-values': 'Reset values',
        speed: 'Speed',
        slower: 'slower',
        faster: 'faster',
        stability: 'Stability',
        'more-variable': 'more variable',
        'more-stable': 'more stable',
        similarity: 'Similarity',
        'style-exaggeration': 'Style exaggeration',
        none: 'none',
        exaggerated: 'exaggerated',
        'speaker-boost': 'Speaker boost',
        'speed-tooltip':
            'Controls the speed of the generated speech. Values below 1.0 slow it down, values above 1.0 speed it up. Extreme values may affect quality.',
        'stability-tooltip':
            'Higher stability makes the voice more consistent between re-generations but can sound monotone. For longer texts we recommend lowering this value.',
        'similarity-tooltip':
            'Higher enhancement improves overall voice clarity and target speaker similarity. Very high values can cause artifacts—find an optimal balance.',
        'style-tooltip':
            'High values exaggerate the speaking style compared to the uploaded audio. They can increase instability. Setting 0.0 speeds up generation and is the default.',
        'stability-warning': 'Under 30% may lead to instability',
        'style-warning': 'Over 50% may lead to instability',
        'available-languages': 'Available languages',
        'supported-languages':
            'We support 29 languages: English (USA, UK, Australia, Canada), Japanese, Chinese, German, Hindi, French (France, Canada), Korean, Portuguese (Brazil, Portugal), Italian, Spanish (Spain, Mexico), Indonesian, Dutch, Turkish, Filipino, Polish, Swedish, Bulgarian, Romanian, Arabic (Saudi Arabia, UAE), Czech, Greek, Finnish, Croatian, Malay, Slovak, Danish, Tamil, Ukrainian & Russian.',
        characters: 'characters',
        'generations-remaining_one': '{{count}} generation remaining today',
        'generations-remaining_other': '{{count}} generations remaining today',
        'voice-settings': 'Voice Settings',
        'apply-settings': 'Apply settings',
        high: 'high',
        low: 'low',
        'voice-settings-message': 'Adjust the voice to your preferences.',
        'voice-settings-title': 'Voice Settings',
        'step-text': 'Step {{stepNumber}}/{{totalSteps}}: $t(audio-generation:steps.{{stepName}})',
        'queue-position_one': '{{count}} job ahead',
        'queue-position_other': '{{count}} jobs ahead',
        'time-text': 'Ready in ~{{remainingSeconds}}s',
        'step-timeout-warning': 'The current step is taking longer than expected',
        steps: {
            IN_QUEUE: 'In Queue',
            MODERATION: 'Content verification',
            GENERATION: 'Generation',
            COMPLETE: 'Complete'
        },
        continue: 'Unlock',
        sending: 'Sending code...',
        'error-title': 'Unable to generate',
        'edit-to-continue': 'Please edit your text to try again.',
        verify: 'Verify',
        verifying: 'Verifying...',
        'verification-code-sent':
            "We've sent a code to {{email}}. Please enter it here. Make sure you also check your Spam folder!",
        'verify-email-title': 'Verify Email',
        'verification-code': 'Code',
        'verification-code-length': 'Verification code must be exactly 6 characters long',
        'consent-required': 'You need to consent to receive marketing emails to continue.',
        moderation: {
            'flagged-text-description':
                'This text was rejected by our automatic content moderation for the following reasons:',
            'please-rephrase': 'We are unable to generate audio for this text. Please rephrase it.',
            'contact-support':
                'If you believe this was a mistake or would like to request an exception, please contact me:'
        }
    },
    download: {
        title: 'Ordered. Generated. Done!',
        thanks: 'Thank you for choosing my voice for your project!',
        'download-ready-soon': 'Your AI audio file is being created and will be ready for download in a few minutes.',
        'details-sent': 'Order confirmation sent to <strong>{{emailAddress}}</strong>.',
        'check-inbox': 'Download link will follow via email (check spam too!)',
        'including-invoice': 'Invoice, order number & release document included.',
        'secure-download-id': 'Secure download ID',
        'download-ready': 'Audio ready!',
        'download-ready-description': 'Your audio file is ready for download',
        'order-more': 'Order more',
        'claim-account': 'Claim Account',
        'download-order': 'Download Order',
        'download-preparing': 'Your download is being prepared. This will take a few minutes...',
        'error-preparing-download': 'There was an error preparing your download. Please contact support.',
        'create-account-instruction': "You can also create an account. All that's still needed is a password:",
        password: 'Password',
        'repeat-password': 'Repeat Password',
        'account-created-successfully': 'Your account was created successfully!',
        'open-account': 'Open Account',
        'password-required': 'Password is required',
        'password-min-length': 'Password must be at least {{min}} characters',
        'password-repeat-required': 'Password confirmation is required',
        'passwords-dont-match': 'Passwords do not match',
        'there-you-go': 'Und bitte!',
        'problem-support': 'Issues?'
    },
    progress: {
        'starting-soon': 'Starting soon...',
        'queue-position': 'Queue position: {{position}}',
        generating: 'Generating audio...',
        finalizing: 'Finalizing...'
    },
    checkout: {
        header: 'Choose your takes!',
        description:
            'Same text, different takes – choose and pay only for what you need. Note: With identical text, you only pay a surcharge per take. If the text changes by more than 5%, a new module is charged.',
        'no-recordings-yet': 'Please generate a text first to see something here!',
        play: 'Play',
        stop: 'Stop',
        'accept-terms': 'Yes, I accept the <0>terms and conditions</0>.',
        'order-now': 'Order now',
        'voice-owner-approved': 'Voice Owner Approved',
        'allowed-medium': 'Permitted use',
        format: 'Format',
        'including-release-document': 'Including release document',
        'download-after-payment': 'Download right after payment',
        columns: {
            version: 'Take',
            text: 'Text',
            buy: 'Buy',
            actions: ''
        },
        variants: 'variant',
        variants_other: 'variants',
        takes_one: 'take',
        takes_other: 'takes',
        'line-item_zero': '{{speakerName}} - {{mediumTitle}}: {{textLength}} characters',
        'line-item':
            '{{speakerName}} - {{mediumTitle}}: {{textLength}} characters, incl. {{count}} $t(checkout:variants, { "count": {{count}} })',
        'has-coupon': "I've got a coupon!",
        'percentage-coupon': '{{discount}}% off',
        coupon: 'Code',
        cancel: 'No, keep version',
        confirmDeleteTake: 'Do you really want to delete this version?',
        delete: 'Yes, delete'
    },
    footer: {
        gtc: 'Terms of use',
        imprint: 'Imprint',
        'contact-real-voice': 'Contact natural voice',
        copyright: 'Ⓒ CrispyVoice {{year}}'
    },
    login: {
        meta: {
            title: 'Login',
            subTitle: 'CrispyVoice Speaker Portal'
        },
        email: 'E-Mail address',
        password: 'Password',
        'remember-me': 'remember me',
        login: 'Login',
        signIn: 'Sign In',
        forgotPassword: 'Forgot your password?',
        createAnAccount: 'Create an account!',
        resetPassword: 'Reset password',
        backToLogin: 'Back to Login',
        checkYourEmail: 'Check your email',
        emailVerificationCodeSent: "We've sent you a code to verify your email address.",
        newPassword: 'New Password',
        confirmNewPassword: 'Confirm New Password'
    },
    onboarding: {
        emails: {
            welcome: {
                subject: 'Welcome to CrispyVoice!',
                heading: 'Welcome to CrispyVoice, {{user_name}}!',
                login: 'Login here'
            },
            password: {
                subject: 'CrispyVoice: Your Account Password',
                heading: 'CrispyVoice account password',
                'password-text': "Here's your initial account password:",
                login: 'Login here',
                'change-it': 'We highly suggest that you change it after the initial login.'
            }
        }
    },
    navigation: {
        title: 'CrispyVoice portal',
        subTitle: 'welcome',
        home: 'Home',
        purchases: 'Purchases'
    },
    contact: {
        title: 'Contact',
        name: 'Name',
        email: 'Email',
        message: 'Message',
        submit: 'Send message',
        success: 'Message sent!',
        'name-too-long': 'Please use a shorter name',
        'message-required': 'Message is required',
        'message-too-short': 'Please include some more details (at least 20 characters)',
        'message-too-long': 'Please shorten your message to maximum 500 characters'
    },
    gtc: {
        heading: 'General Terms and Conditions (GTC) for Customers of Voice Artists on CrispyVoice',
        text:
            '# 1. Scope and Contracting Parties\n1.1. These General Terms and Conditions (hereinafter "GTC") govern the contractual\nrelationship between me as a professional voice artist (hereinafter "Voice Artist") and\nyou as the end customer (hereinafter "Customer") who purchases my AI-cloned voice\nthrough the CrispyVoice platform (hereinafter "Platform").  \n1.2. The CrispyVoice Platform serves exclusively as a technical service provider and\nintermediary between me and you. Your contractual partner is exclusively me as the\nVoice Artist.  \n1.3. By ordering an AI-generated audio file with my voice, you fully accept these GTC.\n# 2. Service Description\n2.1. As a Voice Artist, I offer the creation of audio files with my AI-cloned voice through\nthe Platform. The audio files are created based on the text you submit.  \n2.2. The audio files are provided in MP3 format with 128 kbit/s in mono quality.  \n2.3. After successful payment, you will receive a download link to the created audio file\nas well as a unique identification code associated with this file.  \n2.4. I reserve the right to reject texts that violate applicable law or contain ethically\nobjectionable content. The review is automated through AI systems of the Platform.  \n# 3. Registration and Ordering Process\n3.1. To use my AI voice through the Platform, free registration is required. You agree to\nprovide truthful information and to keep your access data confidential.  \n3.2. The ordering process includes the following steps: a) Selection of my voice b)\nSelection of the intended use and corresponding license c) Entry of the text to be\nvoiced d) Selection of the desired number of takes/versions e) Review and confirmation\nof the order f) Payment g) Immediate download of the generated audio file  \n3.3. You will receive access to the ordered audio file immediately after successful\npayment. The contract is considered fulfilled at this point.\n# 4. Prices and Payment Terms\n4.1. The prices for the various intended uses are set by me as the Voice Artist and are\ntransparently displayed on the Platform.  \n4.2. The base prices each include a certain set of characters characters. Additional charges as indicated on the\nPlatform apply for each additional character.  \n4.3. When ordering multiple takes or versions of the same text, a percentage surcharge\nis calculated. For text changes in additional takes, the license fee is charged twice if this\noption was selected.  \n4.4. The total price will be clearly displayed to you before the final order confirmation.  \n4.5. Payment is made exclusively through the payment methods offered (credit card via\nStripe or TWINT). All payments are due immediately and will be collected in full before\nthe audio file is provided.  \n4.6. Invoicing is done through Stripe, showing the applicable value-added tax (VAT) in the\nCustomer\'s country, provided that I as the Voice Artist am subject to VAT. For\ninternational transactions, the VAT rate of the country in which the Customer is based\napplies, if required by applicable tax regulations.  \n4.7. For Customers based in the European Union: Upon providing a valid VAT\nidentification number, the invoice can be issued without VAT, provided that the legal\nrequirements for an intra-community service are met.  \n# 5. License and Usage Rights\n5.1. By purchasing an audio file, you receive from me as the Voice Artist a non-exclusive,\nnon-transferable right to use the AI-generated voice for the intended use selected\nduring the ordering process.  \n5.2. The license duration is determined by me as the Voice Artist and is clearly displayed\nfor each usage type during the ordering process. The specific duration of your license is\ndocumented in your order confirmation and may include: a) Limited time period (e.g., 1\nyear, 2 years) b) Perpetual license (unlimited in time) c) Custom license periods as\nspecifically stated  \n5.3. The usage right is valid worldwide, unless otherwise specified by me during the\nordering process.  \n5.4. You are not entitled to: a) Use the audio file for purposes other than those\npurchased b) Transfer or sell the audio file to third parties c) Use the audio file for\ntraining speech models or AI systems d) Modify or edit the audio file e) Use the audio\nfile for illegal, fraudulent, or defamatory purposes f) Continue using the audio file after\nthe license period has expired (for time-limited licenses)  \n5.5. In case of violation of these provisions, the usage right automatically expires, and I\nreserve the right to take legal action.  \n5.6. If you wish to extend a time-limited license or modify the usage rights, you must\nplace a new order or contact me directly through the Platform.  \n5.7. For commercial uses, you are responsible for maintaining records of when and how\nthe audio file was used to ensure compliance with the license duration.  \n# 6. Identification of AI-generated Content\n6.1. Each purchased audio file receives a unique identification code, which is included in\na release document and serves to uniquely identify the licensed file.  \n6.2. You agree to comply with the applicable legal and platform-specific labeling\nrequirements for AI-generated content when using the audio file.  \n6.3. If a platform or medium on which you use the audio file prescribes specific labeling\nof AI-generated content, you are obligated to provide such labeling. The unique\nidentification code provided with the audio file can be used for this purpose.  \n6.4. Upon request, I will provide you with confirmation that you have legally purchased\nand licensed the audio file.\n# 7. Warranty and Liability\n7.1. As a Voice Artist, I do not guarantee the accuracy of the content of the texts you\nsubmit.  \n7.2. Complaints regarding the quality of AI-generated audio files are excluded. When\nbooking my natural voice, the amount already paid may be credited at my discretion.  \n7.3. My liability as a Voice Artist is limited to intent and gross negligence. Liability for\nslight negligence is excluded to the extent legally permissible.  \n7.4. I am not liable for damages resulting from misuse or illegal use of the audio files by\nyou.  \n7.5. You indemnify me as the Voice Artist from all claims by third parties that may arise\nfrom your use of the audio files.  \n7.6. The maximum liability is in any case limited to the purchase price paid by you.\n# 8. Data Protection\n8.1. Your personal data (company, address, phone number, email) will be collected and\nprocessed exclusively for the purpose of contract execution and in accordance with\napplicable data protection regulations.  \n8.2. The data is stored on AWS and Hetzner servers in the USA and in Europe. You expressly consent to this storage.  \n8.3. The texts you submit are used exclusively for creating the audio files and are only\nvisible to me as the Voice Artist.  \n8.4. The created audio files are stored indefinitely and remain available for you to\ndownload.  \n8.5. You have the right to information, correction, deletion, and restriction of the\nprocessing of your personal data at any time. Corresponding requests should be\ndirected to my contact email.\n# 9. Copyright and Intellectual Property\n9.1. The AI model for generating the voice is the intellectual property of CrispyVoice.  \n9.2. The personality rights to my original voice remain with me as the Voice Artist.  \n9.3. You acquire exclusively the usage rights to the generated audio file as defined in\nSection 5.  \n9.4. You are obligated to observe all applicable copyright and personality rights\nprovisions when using the audio files.  \n# 10. Contract Duration and Termination\n10.1. The contract between me as the Voice Artist and you ends with the provision of the\naudio file; the usage rights continue in accordance with the conditions specified in\nSection 5.  \n10.2. I am entitled to revoke the usage rights with immediate effect if you violate these\nGTC, especially if the audio files are used for illegal or defamatory purposes.\n# 11. Changes to the GTC\n11.1. I reserve the right to change these GTC at any time. Changes will be communicated\nto you via email or through the newsletter.  \n11.2. You will be informed about changes to the voice model or terms of use via\nnewsletter if you have subscribed to it.  \n11.3. For already purchased audio files, the GTC valid at the time of purchase apply.\n# 12. Dispute Resolution\n12.1. In the event of disputes arising from or in connection with this contract, we commit\nto first seeking an amicable solution. Please direct complaints and claims directly to me\nas the Voice Artist using the provided contact email.  \n12.2. I will respond to your complaint within 14 days and propose a solution.  \n12.3. If no agreement can be reached, mediation according to the rules of the Swiss\nChamber of Commercial Mediation (SCCM) or the Swiss Federation for Mediation (SFM)\nmay be conducted before pursuing legal action. The costs of mediation shall be borne\nequally by both parties unless otherwise agreed.  \n# 13. Final Provisions\n13.1. Should individual provisions of these GTC be or become invalid, the validity of the\nremaining provisions shall remain unaffected.  \n13.2. The law of the country in which I as the Voice Artist have my residence applies\nexclusively, excluding the UN Convention on Contracts for the International Sale of\nGoods.  \n13.3. The place of jurisdiction for all disputes arising from or in connection with these\nGTC is my residence as the Voice Artist, to the extent legally permissible.  \n13.4. These GTC were last updated on [01.05.2025].'
    },
    emails: {
        'anonymous-registration': {
            subject: 'Your code for unlimited generation',
            greeting: 'Hi!',
            'code-text': "Almost there – here's your code:",
            'explanation-text': 'Just enter it in the field and keep generating.',
            'expiration-text': 'Code valid for 10 minutes.',
            'there-you-go': 'Und bitte!'
        }
    }
};
